export default __webpack_public_path__ + "static/media/warning--traffic-merges-at-signalized-intersections--g1.15593cdb.png";